export const get_messages = `query get_messages($paginator: Paginator!){
    get_messages(paginator: $paginator){
        messages{
            id
            time
            type
            subject
            subject_en
            text
            text_en
            awaiting_acception
            accepted
            unread
            has_attachment
        }
        page
        page_count
    }
}`;
